  window.addEventListener('scroll', function() {
    var header = document.querySelector('.header');
    if (window.pageYOffset > 0) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
    
    if (window.pageYOffset === 0) {
      header.classList.add('transparent');
    } else {
      header.classList.remove('transparent');
    }
  });


  document.addEventListener('DOMContentLoaded', function() {
    var pTag = document.querySelector('.bar_text p');
    pTag.id = 'guaranteeText';

    // Add an event listener to check the screen width and hide the specific text if necessary
    window.addEventListener('resize', function() {
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var guaranteeText = document.getElementById('guaranteeText');

      if (screenWidth < 749) {
        guaranteeText.innerHTML = guaranteeText.innerHTML.replace("Satisfaction Guaranteed or your Money Back Is our Promise", "<span style='display:none'>Satisfaction Guaranteed or your Money Back Is our Promise</span>");
      } else {
        guaranteeText.innerHTML = guaranteeText.innerHTML.replace("<span style='display:none'>Satisfaction Guaranteed or your Money Back Is our Promise</span>", "Satisfaction Guaranteed or your Money Back Is our Promise");
      }
    });

    // Trigger the event once on page load to handle the initial state
    window.dispatchEvent(new Event('resize'));
  });